import { env } from "./config/env";

/**
 * App entry — branches on the build-time product selector `VITE_APP_MODE` (config/env.ts):
 *
 *   history (DEFAULT) → the public WW2 archive (src/bootstrapHistory.tsx), byte-for-byte
 *                       unchanged from before the branch existed.
 *   osint             → the access-controlled OSINT console (src/osint/bootstrap.tsx).
 *
 * Both entries are DYNAMIC-imported so each product is its own chunk: the history graph never
 * enters an osint build and vice-versa (extractability — see src/osint/README.md). This file
 * itself pulls in neither product's modules statically, so the branch decides the whole graph.
 */
const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

if (env.VITE_APP_MODE === "osint") {
  const { bootstrapOsint } = await import("./osint/bootstrap");
  bootstrapOsint(rootEl);
} else {
  const { bootstrapHistory } = await import("./bootstrapHistory");
  await bootstrapHistory(rootEl);
}
